'use client'
import type { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { mq, rgbAlpha } from '@/styles'
import type { TypeColors } from '@/styles'

type Props = {
  children: ReactNode
  bgColor?: TypeColors
  color?: TypeColors
}

export const WrapperForTwoCols: FC<Props> = ({ children, bgColor, color }) => {
  return (
    <Div $bgColor={bgColor} $color={color}>
      {children}
      <div className='vr' />
    </Div>
  )
}

type DivProps = {
  $bgColor?: TypeColors
  $color?: TypeColors
}

const Div = styled.div<DivProps>`
  background-color: ${({ $bgColor }) => `var(${$bgColor})` || 'var(--color-background--dark)'};
  border-bottom: 1px solid ${rgbAlpha('--color-white', .2)};
  color: ${({ $color }) => `var(${$color})` || 'var(--color-white)'};
  margin-top: 70px;
  position: relative;
  width: var(--viewport-width);
  width: var(--viewport-width--dynamic);

  ${mq.greaterThan('tablet')} {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    min-height: unset;
  }

  ${mq.greaterThan('desktop-xs')} {
    margin-top: 90px;
  }

  .vr {
    display: none;

    ${mq.greaterThan('tablet')} {
      background-color: ${rgbAlpha('--color-white', .2)};
      display: block;
      height: 100%;
      position: absolute;
      left: 50%;
      bottom: 0;
      top: 0;
      transform: translateX(-50%);
      user-select: none;
      width: 1px;
    }
  }
`
